<template>
<div v-on:click="select" v-bind:class="{color: true, active: color === active_color}" v-bind:style="{background: color}"></div>
</template>

<script>

export default {
  name: 'color',
  props: ['color', 'active_color'],
  methods: {
    select: function() {
        this.$emit('activate', this.color)
    }
  },
  data () {
    return {
    }
  }
}
</script>

<style scoped>

.color {
    width: 30px;
    height: 30px;
    float: left;
    margin-right: 5px;
    margin-bottom: 5px;
    border-radius: 4px;
    box-sizing: border-box;
}

.color.active {
    border: solid 3px black;
    border: solid 3px rgba(255, 255, 255, 0.6);
}

</style>



// WEBPACK FOOTER //
// Color.vue?9392f8a4